"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputRootBase = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _inputFieldBaseProps = require("../../../util/inputFieldBaseProps");
var _formInputTheme = require("./formInputTheme");
const TextInputRootBase = (0, _styled.default)("div")`
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: ${_ref => {
  let {
    themeMode,
    inputFieldHeight
  } = _ref;
  return `var(--sds--form--height--${inputFieldHeight === 32 ? "default" : "large"}, ${_formInputTheme.formInputTheme.height[(0, _inputFieldBaseProps.getInputFieldHeightValue)(themeMode, inputFieldHeight)](themeMode)}px)`;
}};
    color: var(--sds--form--color--value);
`;
exports.TextInputRootBase = TextInputRootBase;
//# sourceMappingURL=TextInputRootBase.js.map